export const accountIdToEnglishName = {
  5088620: 'CHINA GAMEDAY',
  5063085: 'CHINA NATIONAL BASKETBALL TEAM',
  5063611: 'CHINA NATIONAL ATHLETICS TEAM',
  5063327: 'CHINESE NATIONAL FOOTBALL TEAM',
  5064296: "CHINESE MEN'S BASKETBALL TEAM",
  5064299: "CHINESE WOMEN'S BASKETBALL TEAM",
  5064297: "CHINESE MEN'S NATIONAL YOUTH BASKETBALL TEAM",
  5064326: "CHINESE WOMEN'S OLYMPIC BASKETBALL TEAM",
  5064325: "CHINESE WOMEN'S NATIONAL YOUTH BASKETBALL TEAM",
  5088221: 'GUANGZHOU',
  5088265: 'BEIJING GUOAN',
  5088266: 'GUANGZHOU CITY',
  5088274: 'SHANDONG TAISHAN',
  5088223: 'SHANGHAI PORT',
  5088270: 'TIANJIN TIGERS',
  5088224: 'SHANGHAI SHENHUA',
  5088273: 'HENAN SONGSHAN LONGMEN',
  5088276: 'WUHAN YANGTZE RIVER',
  5088267: 'HEBEI FC',
  5088269: 'DALIAN PROFESSIONAL',
  5088272: 'SHENZHEN FC',
  5091566: 'CANGZHOU MIGHTY LIONS',
  5093215: 'CHANGCHUN YATAI',
  5093882: 'ZHEJIANG FC',
  5096192: 'CHENGDU RONGCHENG',
  5096193: 'WUHAN THREE TOWNS',
  5096194: 'MEIZHOU HAKKA',
  5088277: 'CSL COMPANY',
  825591: "WOMEN'S 7'S RUGBY"
};
